import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "station-form-category-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "station-form-category-title" }, "Informações do plantão", -1)
const _hoisted_3 = { class: "station-form-category-content" }
const _hoisted_4 = { class: "station-form-category-columns text-left justify-start" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-sg" }, "Nossa equipe", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'station.details.form',
  props: ['ourTeam'],
  emits: ['update:ourTeam'],
  setup(__props, { emit }) {



const setOurTeam = (v: boolean) => emit('update:ourTeam', v)

return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_v_radio_group, {
            "onUpdate:modelValue": setOurTeam,
            "model-value": __props.ourTeam,
            column: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_radio, {
                label: "Sim",
                color: "primary",
                value: true
              }),
              _createVNode(_component_v_radio, {
                label: "Não",
                color: "primary",
                value: false
              })
            ]),
            _: 1
          }, 8, ["model-value"])
        ])
      ])
    ])
  ]))
}
}

})